import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useParams, useHistory } from 'react-router-dom'
import moment from 'moment'
import { notify, date, invoicebasehelper } from '@/_helpers'
import { API, Card, Help, Table, Pagination, Submit, Date } from '@enkla-gui'
import Modal from 'react-modal'

export default function Invoicebases(props) {
  const { register, handleSubmit, control } = useForm()
  const [company, setCompany] = useState(null)
  const [error, setError] = useState(null)
  const [invoicebases, setInvoicebases] = useState([])
  const [sorting, setSorting] = useState({})
  const [modal, setModal] = useState(false)
  const [quickCreateModal, setQuickCreateModal] = useState(false)
  const [quickCreating, setQuickCreating] = useState(false)
  let { page } = useParams()
  const history = useHistory()

  useEffect(() => {
    if (!props.lease || props.lease === undefined) return
    fetchInvoicebases()

    API.get(`api/company/${props.lease.entity.company_id}`).then(company => setCompany(company))
  }, [props.lease, sorting])

  const fetchInvoicebases = async (p = page || 1) => {
    API.get(`api/invoicebase/lease/${props.lease.id}`, {
      page: p,
      ...sorting
    }).then(invoicebases => {
      setInvoicebases(invoicebases)
    })
  }
  const create = data => {
    API.post('api/invoicebase', data)
      .then(res => {
        fetchInvoicebases()
        setModal(false)
        if (company.invoicingconfig && company.invoicingconfig.generate_day !== null) {
          notify.alert(
            'Underlaget har skapats',
            'Denna uthyrning är berörd av automatisk generering av hyresavier. När du manuellt skapar upp ett underlag bör du därför se till att datum för nästa fakturamånad stämmer. Mer information kan du hitta genom att klicka på hjälpen nere till höger och söka på "hyresintervall" '
          )
        } else {
          notify.toast('Underlaget har skapats')
        }
        history.push(`/invoicebase/${res.invoicebase.id}`)
      })
      .catch(([err, res]) => {
        setError({
          message: res.message,
          data: res.data
        })
      })
  }

  const quickCreate = (isNextMonth) => {
    setQuickCreating(true)
    const now = moment.utc()
    let start, stop

    if (isNextMonth) {
      start = now.clone().utc().add(1, 'month').startOf('month')
    } else {
      start = now.clone().utc().startOf('month')
    }

    const intervalMap = { MONTHLY: 1, QUARTERLY: 3, YEARLY: 12 }
    const interval = intervalMap[props.lease?.payment_interval]
    stop = start.clone().utc().add(interval - 1, 'month').endOf('month').hour(0).minute(0).second(0)

    const data = {
      lease_id: props.lease.id,
      start: start.unix(),
      stop: stop.unix(),
      create_in_integration: true
    }

    API.post('api/invoicebase', data)
      .then(res => {
        fetchInvoicebases()
        setQuickCreateModal(false)
        notify.toast('Hyresavin har skapats')
        history.push(`/invoicebase/${res.invoicebase.id}`)
      })
      .catch(([err, res]) => {
        notify.alert('Något gick fel', res.message, 'error')
      })
      .finally(() => {
        setQuickCreating(false)
      })
  }
  return (
    <>
      <Card
        title='Hyresavier'
        icon='fas fa-file-invoice'
        collapsed={invoicebases?.data?.length === 0}
        buttons={{
          header: [
            {
              icon: 'fas fa-plus-square', text: 'Skapa', callback: () => setModal(true),
              hidden: props.lease?.state?.status === 'inactive'
            },
            {
              icon: 'fas fa-bolt', text: 'Snabbskapa', callback: () => setQuickCreateModal(true),
              hidden: props.lease?.state?.status === 'inactive'
            },
          ]
        }}>
        <Table
          rows={invoicebases.data}
          empty={{ text: 'Det finns inte några hyresavier', icon: 'fas fa-file-invoice' }}
          sorting={sorting}
          useSorting={sort => setSorting({ ...sort })}
          link={`/#!/invoicebase/@{id}`}
          functions={{
            status: status => <span class={`badge w-100 bg-${invoicebasehelper.status(status).color}`}>{invoicebasehelper.status(status).label}</span>,
            period: invoice => date.short(invoice.start) + ' - ' + date.short(invoice.stop),
            reference: ref => (ref === null ? 'Ej skapad' : ref)
          }}
          keys={['reference>function:reference', 'status>function:status', 'title', 'payment_left>currency', '_this>function:period']}
          headers={[
            {
              value: 'Referens',
              class: 'min'
            },
            {
              key: 'status',
              value: 'Status',
              sortable: true,
              class: 'min'
            },
            {
              key: 'invoice_type',
              value: 'Typ',
              sortable: true,
              class: 'min'
            },
            {
              key: 'payment_left',
              sortable: true,
              value: 'Kvar att betala'
            },
            {
              key: 'stop',
              sortable: true,
              value: 'Period'
            }
          ]}
        />
        <Pagination data={invoicebases} fetch={fetchInvoicebases} />
      </Card>
      <Modal isOpen={modal} onRequestClose={() => setModal(false)} className='no-padding'>
        <Card
          collapsed={null}
          title='Skapa Underlag'
          icon='fas fa-fw fa-file-invoice'
          buttons={{
            header: [{ callback: () => setModal(false), icon: 'fas fa-times', text: 'Avbryt', bg: 'light' }],
            footer: [<Submit onSubmit={handleSubmit(create)} text='Skapa' />]
          }}>
          <input type='hidden' {...register('lease_id')} value={props.lease.id} />
          <div class='row mb-3'>
            <Date label='Från' controls={{ control }} name='start' error={error} />
          </div>
          <div class='row mb-3'>
            <Date label='Till' controls={{ control }} name='stop' error={error} />
          </div>
        </Card>
      </Modal>
      <Modal isOpen={quickCreateModal} onRequestClose={() => setQuickCreateModal(false)} className='no-padding'>
        <Card
          collapsed={null}
          title='Snabbskapa Hyresavi'
          icon='fas fa-fw fa-bolt'
          buttons={{
            header: [{ callback: () => setQuickCreateModal(false), icon: 'fas fa-times', text: 'Avbryt', bg: 'light' }]
          }}>
          <div class='d-grid gap-2'>
            <Help>
              Denna funktion hjälper dig att snabbare hantera manuella hyresavier.
              <br />

              Hyresavin kommer skapas upp direkt med den fakturametod samt betalningsvillkor du ställt in i företagets {' '}
              <a href={`#!/company/${props.lease?.company?.id}/invoicingconfig`}>aviseringsinställningar</a>
            </Help>
            {quickCreating ? (
              <div class='text-center py-4'>
                <i class='fas fa-spinner fa-spin fa-2x'></i>
                <p class='mt-2'>Skapar hyresavi...</p>
              </div>
            ) : (
              <>
                <button class='btn btn-primary' onClick={() => quickCreate(true)}>
                  Skapa fullständig hyresavi för <b>nästkommande</b> månad
                </button>
                <button class='btn btn-primary' onClick={() => quickCreate(false)}>
                  Skapa fullständig hyresavi för <b>nuvarande</b> månad
                </button>
              </>
            )}
          </div>
        </Card>
      </Modal>
    </>
  )
}
